// extracted by mini-css-extract-plugin
module.exports = {"main":"LinkCard_main__4Xd4u"};